import React from 'react'
import { useStoreState } from 'easy-peasy'
import { motion } from 'framer-motion'
import pages from './index'

const variantsWithAnimation = {
  hidden: {
    display: 'none',
    opacity: 0,
    x: 50,
  },
  visible: {
    display: 'block',
    opacity: 1,
    x: 0,
  },
  leave: {
    display: 'none',
    opacity: 0,
    x: -50,
  },
}

const variantsNoAnimation = {
  hidden: {
    display: 'none',
  },
  visible: {
    display: 'block',
  },
  leave: {
    display: 'none',
  },
}

export default function Transition({ step, type }) {
  const [currentStep, config] = useStoreState(state => [
    state.steps.step,
    state.form.config,
  ])
  const ChildrenTag = pages[type]
  const { initial, variantType } = config.animationForm
  const variant =
    variantType === 'no animation'
      ? variantsNoAnimation
      : variantsWithAnimation

  return (
    <motion.div
      // className="row"
      initial={initial || 'hidden'}
      animate={(() => {
        if (currentStep === step) return 'visible'
        if (currentStep > step) return 'leave'
        return 'hidden'
      })()}
      variants={variant}
    >
      <ChildrenTag step={step} />
    </motion.div>
  )
}
